//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { plural } from '@razlet/utils';
import cms from '~/mixins/cms';
import TrackingMethods from '~/api/methods/tracking';
import Shipment from '~/api/entities/shipment';
import ShipmentMethods from '~/api/methods/shipment';

function normalizeAwb (value) {
  const awb = Array.isArray(value) ? value[0] : value;
  return typeof awb === 'string' ? awb.replace(/\s+/g, '') : '';
}

export default {
  cmsId: 'tracking',
  name: 'tracking',
  platforms: ['CABINET'],
  access: '*',
  mixins: [cms],
  data () {
    return {
      loading: false,
      shipment: null,
      loadState: null,
      shipmentAvailable: false,
    };
  },
  computed: {
    title () {
      return this.content.heading;
    },
    locale () {
      return this.$i18n?.locale || this.$locale || 'ru';
    },
    currentAwb () {
      return normalizeAwb(this.$route.query.awb);
    },
    loadStateContent () {
      if (!this.loadState) return {};
      const prefix = `cabinet.tracking.page.${this.loadState}`;
      return {
        title: this.$t(`${prefix}Title`),
        description: this.$t(`${prefix}Description`),
      };
    },
    trackingInfo () {
      if (!this.shipment) return [];
      const cargo = this.shipment.cargo || {};
      const route = [];
      this.shipment.route.forEach(segment => {
        if (segment.departure && !route.length) route.push(segment.departure);
        if (segment.arrival && route[route.length - 1] !== segment.arrival) {
          route.push(segment.arrival);
        }
      });
      if (!route.length) {
        [this.shipment.departure, this.shipment.arrival].forEach(airport => {
          if (airport && route[route.length - 1] !== airport) route.push(airport);
        });
      }
      const cargoParts = [
        cargo.pieces !== undefined && cargo.pieces !== null
          ? `${this.formatNumber(cargo.pieces)} ${plural(
            cargo.pieces,
            this.$t('base.piecesPlural')
          )}`
          : '',
        cargo.weight !== undefined && cargo.weight !== null
          ? `${this.formatNumber(cargo.weight)} ${this.$t('cabinet.tracking.page.weightUnit')}`
          : '',
        cargo.volume !== undefined && cargo.volume !== null
          ? `${this.formatNumber(cargo.volume)} ${this.$t('cabinet.tracking.page.volumeUnit')}`
          : '',
      ].filter(Boolean);
      return [
        {
          title: this.$t('cabinet.tracking.page.route'),
          value: route.join(' → '),
        },
        {
          title: this.$t('cabinet.tracking.page.commodity'),
          value: cargo.commodity?.name || cargo.commodity?.code,
        },
        {
          title: this.$t('cabinet.tracking.page.cargo'),
          value: cargoParts.join(' · '),
        },
      ].filter(item => item.value);
    },
  },
  watch: {
    '$route.query.awb' (value) {
      this.loadTracking(value);
    },
    isUser (value) {
      if (!value) {
        this.shipmentAvailable = false;
        return;
      }
      if (this.shipment && this.currentAwb) {
        this.checkShipmentAvailability(this.currentAwb)
          .then(available => this.shipmentAvailable = available);
      }
    },
  },
  mounted () {
    if (this.currentAwb) this.loadTracking(this.currentAwb);
  },
  methods: {
    formatNumber (value) {
      return new Intl.NumberFormat(
        String(this.locale).startsWith('en') ? 'en-US' : 'ru-RU',
        { maximumFractionDigits: 3 }
      ).format(value);
    },
    async checkShipmentAvailability (awb) {
      if (!this.isUser) return false;

      try {
        const response = await new ShipmentMethods().getOne(awb);
        return response?.status === 200;
      } catch {
        return false;
      }
    },
    async loadTracking (value) {
      const awb = normalizeAwb(value || this.currentAwb);
      if (!awb) {
        this.shipment = null;
        this.loadState = null;
        this.shipmentAvailable = false;
        return;
      }

      if (awb !== this.currentAwb) {
        await this.$router.push({
          name: 'tracking',
          query: { awb },
        });
        return;
      }

      this.loading = true;
      this.loadState = null;
      this.shipmentAvailable = false;

      try {
        const response = await new TrackingMethods().getStatus(awb);
        const data = response?.data || {};
        if (!data.mAwb && !data.mawb && !data.awb) {
          const notFoundError = new Error(this.$t('cabinet.tracking.page.notFoundTitle'));
          notFoundError.statusCode = 404;
          throw notFoundError;
        }
        this.shipment = new Shipment(data);
        this.shipmentAvailable = await this.checkShipmentAvailability(awb);
      } catch (error) {
        this.shipment = null;
        this.shipmentAvailable = false;
        const errorCode = error?.response?.status || error?.statusCode || error?.code;
        const isNotFound = Number(errorCode) === 404 ||
          /not[._ -]?found/i.test(error?.message || errorCode || '');
        this.loadState = isNotFound ? 'notFound' : 'error';
      } finally {
        this.loading = false;
      }
    },
  },
};
